import { HelpCircle } from 'lucide-react';
import { useLocation } from 'wouter';
import { prepareNewTaskForTour } from '@/pages/canvas/use-workspace-routes';

/** Replay the existing tour only after its New Task anchors are available. */
export function TourHelpButton({ maxBrands: _maxBrands = null }: { maxBrands?: number | null }) {
  const [, navigate] = useLocation();
  return <button type="button" data-testid="sidebar-bottom-help" title="Help — replay tour" aria-label="Help — replay tour" onClick={() => { prepareNewTaskForTour(); navigate('/canvas'); }}
    style={{ width: 32, height: 32, borderRadius: 7, background: 'transparent', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8C8578' }}
    onMouseEnter={event => { event.currentTarget.style.background = '#DCDCDC'; }} onMouseLeave={event => { event.currentTarget.style.background = 'transparent'; }}>
    <HelpCircle style={{ width: 17, height: 17 }} />
  </button>;
}
